import { Timestamp } from 'modules/Monitoring/types'

export const getEndOfDay = (date: Date | Timestamp) => {
  const newDate = new Date(date)

  newDate.setHours(23, 59, 59, 999)

  return newDate.getTime()
}
